import { gql } from '@apollo/client';

export const CREATE_CREW_MEMBER_HOLD_DOWN = gql`
	mutation createCrewMemberHoldDown($input: CrewMemberHoldDownInput!) {
		createCrewMemberHoldDown(input: $input) {
			... on CrewMemberHoldDownErrorResponse {
				errors {
					code
				}
			}
		}
	}
`;
